module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "output-sidebar"
  }, [(!_vm.output) ? _c('div', {
    staticClass: "output-empty"
  }, [_c('svg', {
    staticClass: "output-empty-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 9h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 21V9"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "output-empty-title"
  }, [_vm._v("Outputs will appear here")]), _vm._v(" "), _c('p', {
    staticClass: "output-empty-subtitle"
  }, [_vm._v("Complete the chat to generate your entry point")])]) : [(_vm.showReadyHeader) ? _c('div', {
    staticClass: "output-header"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "output-body"
  }, [_c('div', {
    staticClass: "output-card"
  }, [_c('div', {
    staticClass: "output-card-label"
  }, [_vm._v("KEYWORD")]), _vm._v(" "), _c('div', {
    staticClass: "output-field-row"
  }, [(!_vm.editing.keyword) ? _c('span', {
    staticClass: "output-field-value output-mono"
  }, [_vm._v(_vm._s(_vm.drafts.keyword))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.drafts.keyword),
      expression: "drafts.keyword"
    }],
    staticClass: "output-inline-input output-mono",
    domProps: {
      "value": (_vm.drafts.keyword)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveField('keyword')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelField('keyword')
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.drafts, "keyword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-field-actions"
  }, [(_vm.editing.keyword) ? [_c('button', {
    staticClass: "output-icon-btn output-icon-btn--confirm",
    attrs: {
      "disabled": !_vm.drafts.keyword.trim() || _vm.validating.keyword
    },
    on: {
      "click": function($event) {
        return _vm.saveField('keyword')
      }
    }
  }, [_c('i', {
    class: _vm.validating.keyword ? 'fa fa-spinner fa-spin' : 'fa fa-check'
  })]), _vm._v(" "), _c('button', {
    staticClass: "output-icon-btn",
    on: {
      "click": function($event) {
        return _vm.cancelField('keyword')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])] : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "output-icon-btn",
    class: {
      'output-icon-btn--copied': _vm.copiedKey === 'keyword'
    },
    on: {
      "click": function($event) {
        return _vm.copy(_vm.drafts.keyword, 'keyword', null, 'keyword')
      }
    }
  }, [_c('i', {
    class: _vm.copiedKey === 'keyword' ? 'fa fa-check' : 'fa fa-copy'
  }), _vm._v(" "), (_vm.copiedKey === 'keyword') ? _c('span', {
    staticClass: "output-copied-label"
  }, [_vm._v("Copied!")]) : _vm._e()])], 2)]), _vm._v(" "), (_vm.errors.keyword) ? _c('div', {
    staticClass: "output-validation-error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" " + _vm._s(_vm.errors.keyword))]) : _vm._e(), _vm._v(" "), (!_vm.editing.keyword) ? _c('button', {
    staticClass: "output-click-edit",
    on: {
      "click": function($event) {
        return _vm.startEdit('keyword')
      }
    }
  }, [_vm._v("Click to edit")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "output-card"
  }, [_c('div', {
    staticClass: "output-card-label"
  }, [_vm._v("AD ID")]), _vm._v(" "), (_vm.adId.editing) ? [_c('div', {
    staticClass: "output-field-row output-field-row--top"
  }, [_c('div', {
    staticClass: "output-edit-col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adId.draft),
      expression: "adId.draft"
    }],
    staticClass: "output-inline-input output-mono",
    attrs: {
      "placeholder": "Paste ad link or enter ad ID"
    },
    domProps: {
      "value": (_vm.adId.draft)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveAdId.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelAdId.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adId, "draft", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "output-char-source"
  }, [_vm._v("Paste the full Facebook ad link or type the ad ID directly.")])]), _vm._v(" "), _c('div', {
    staticClass: "output-field-actions output-field-actions--top"
  }, [_c('button', {
    staticClass: "output-icon-btn output-icon-btn--confirm",
    attrs: {
      "disabled": _vm.adId.saving
    },
    on: {
      "click": _vm.saveAdId
    }
  }, [_c('i', {
    class: _vm.adId.saving ? 'fa fa-spinner fa-spin' : 'fa fa-check'
  })]), _vm._v(" "), _c('button', {
    staticClass: "output-icon-btn",
    on: {
      "click": _vm.cancelAdId
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), (_vm.adId.error) ? _c('div', {
    staticClass: "output-validation-error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" " + _vm._s(_vm.adId.error))]) : _vm._e()] : (_vm.adId.value) ? [_c('div', {
    staticClass: "output-field-row"
  }, [_c('span', {
    staticClass: "output-field-value output-mono"
  }, [_vm._v(_vm._s(_vm.adId.value))]), _vm._v(" "), _c('div', {
    staticClass: "output-field-actions"
  }, [_c('button', {
    staticClass: "output-icon-btn",
    class: {
      'output-icon-btn--copied': _vm.copiedKey === 'ad_id'
    },
    on: {
      "click": function($event) {
        return _vm.copy(_vm.adId.value, 'ad_id', null, 'ad_id')
      }
    }
  }, [_c('i', {
    class: _vm.copiedKey === 'ad_id' ? 'fa fa-check' : 'fa fa-copy'
  }), _vm._v(" "), (_vm.copiedKey === 'ad_id') ? _c('span', {
    staticClass: "output-copied-label"
  }, [_vm._v("Copied!")]) : _vm._e()])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.adDetails.loading) ? _c('div', {
    staticClass: "output-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Looking up ad details…")]) : (_vm.adDetails.verified) ? _c('div', {
    staticClass: "output-ad-details"
  }, [_c('div', {
    staticClass: "output-ad-detail-row"
  }, [_c('span', {
    staticClass: "output-ad-detail-label"
  }, [_vm._v("Ad")]), _c('span', {
    staticClass: "output-ad-detail-value"
  }, [_vm._v(_vm._s(_vm.adDetails.ad_name))])]), _vm._v(" "), _c('div', {
    staticClass: "output-ad-detail-row"
  }, [_c('span', {
    staticClass: "output-ad-detail-label"
  }, [_vm._v("Ad set")]), _c('span', {
    staticClass: "output-ad-detail-value"
  }, [_vm._v(_vm._s(_vm.adDetails.adset_name))])]), _vm._v(" "), _c('div', {
    staticClass: "output-ad-detail-row"
  }, [_c('span', {
    staticClass: "output-ad-detail-label"
  }, [_vm._v("Campaign")]), _c('span', {
    staticClass: "output-ad-detail-value"
  }, [_vm._v(_vm._s(_vm.adDetails.campaign_name))])])]) : (_vm.adDetails.checked) ? _c('div', {
    staticClass: "output-ad-unverified"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" I am unable to verify this ad ID.\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "output-click-edit",
    on: {
      "click": _vm.startEditAdId
    }
  }, [_vm._v("Edit")]), _vm._v(" "), (_vm.adId.saved) ? _c('span', {
    staticClass: "output-meta-saved-msg"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Saved")]) : _vm._e()] : [_c('p', {
    staticClass: "output-ad-hint"
  }, [_vm._v("Attach an ad ID to route users who arrive from this ad with a generic message (e.g. \"hi\") to this entry point's journey and welcome message.")]), _vm._v(" "), _c('button', {
    staticClass: "output-ad-attach-btn",
    on: {
      "click": _vm.startEditAdId
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Attach ad ID")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "output-card"
  }, [_c('div', {
    staticClass: "output-card-label"
  }, [_vm._v("WELCOME MESSAGE")]), _vm._v(" "), _vm._l((_vm.drafts.welcomeMessages), function(msg, lang) {
    return _c('div', {
      key: lang,
      staticClass: "output-welcome-block"
    }, [_c('div', {
      staticClass: "output-lang-label"
    }, [_vm._v(_vm._s(lang))]), _vm._v(" "), _c('div', {
      staticClass: "output-field-row output-field-row--top"
    }, [(!_vm.editing.welcomeMessages[lang]) ? _c('span', {
      staticClass: "output-field-value output-welcome-text"
    }, [_vm._v(_vm._s(msg))]) : _c('div', {
      staticClass: "output-edit-col"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.drafts.welcomeMessages[lang]),
        expression: "drafts.welcomeMessages[lang]"
      }],
      staticClass: "output-inline-textarea",
      attrs: {
        "rows": "3"
      },
      domProps: {
        "value": (_vm.drafts.welcomeMessages[lang])
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.cancelWelcome(lang)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.drafts.welcomeMessages, lang, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "output-char-row"
    }, [_c('span', {
      staticClass: "output-char-counter",
      class: {
        'output-char-over': _vm.isWelcomeOver(lang)
      }
    }, [_vm._v("\n                  " + _vm._s((_vm.drafts.welcomeMessages[lang] || '').length) + "/" + _vm._s(_vm.welcomeCharLimit) + "\n                ")]), _vm._v(" "), (_vm.welcomeLimitingChannel) ? _c('span', {
      staticClass: "output-char-source"
    }, [_vm._v(_vm._s(_vm.welcomeLimitingChannel))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "output-field-actions output-field-actions--top"
    }, [(_vm.editing.welcomeMessages[lang]) ? [_c('button', {
      staticClass: "output-icon-btn output-icon-btn--confirm",
      attrs: {
        "disabled": _vm.isWelcomeOver(lang)
      },
      on: {
        "click": function($event) {
          return _vm.saveWelcome(lang)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('button', {
      staticClass: "output-icon-btn",
      on: {
        "click": function($event) {
          return _vm.cancelWelcome(lang)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])] : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "output-icon-btn",
      class: {
        'output-icon-btn--copied': _vm.copiedKey === ("welcome_" + lang)
      },
      on: {
        "click": function($event) {
          return _vm.copy(msg, 'welcome_message', null, ("welcome_" + lang))
        }
      }
    }, [_c('i', {
      class: _vm.copiedKey === ("welcome_" + lang) ? 'fa fa-check' : 'fa fa-copy'
    }), _vm._v(" "), (_vm.copiedKey === ("welcome_" + lang)) ? _c('span', {
      staticClass: "output-copied-label"
    }, [_vm._v("Copied!")]) : _vm._e()])], 2)]), _vm._v(" "), (!_vm.editing.welcomeMessages[lang]) ? _c('button', {
      staticClass: "output-click-edit",
      on: {
        "click": function($event) {
          return _vm.startEditWelcome(lang)
        }
      }
    }, [_vm._v("Click to edit")]) : _vm._e()])
  })], 2), _vm._v(" "), _vm._l((_vm.drafts.phrases), function(phrase, idx) {
    return _c('div', {
      key: idx,
      staticClass: "output-card output-phrase-card"
    }, [_c('div', {
      staticClass: "output-card-label"
    }, [_vm._v("PHRASE " + _vm._s(_vm.drafts.phrases.length > 1 ? idx + 1 : ''))]), _vm._v(" "), _c('div', {
      staticClass: "output-field-row output-field-row--top"
    }, [(!_vm.editing.phrases[idx]) ? _c('span', {
      staticClass: "output-field-value output-mono"
    }, [_vm._v(_vm._s(phrase))]) : _c('div', {
      staticClass: "output-edit-col"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.drafts.phrases[idx]),
        expression: "drafts.phrases[idx]"
      }],
      staticClass: "output-inline-input output-mono",
      domProps: {
        "value": (_vm.drafts.phrases[idx])
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.cancelPhrase(idx)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.drafts.phrases, idx, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "output-char-row"
    }, [_c('span', {
      staticClass: "output-char-counter",
      class: {
        'output-char-over': _vm.isPhraseOver(idx)
      }
    }, [_vm._v("\n                " + _vm._s(_vm.drafts.phrases[idx].length) + "/" + _vm._s(_vm.phraseCharLimit) + "\n              ")]), _vm._v(" "), (_vm.limitingChannel) ? _c('span', {
      staticClass: "output-char-source"
    }, [_vm._v(_vm._s(_vm.limitingChannel))]) : _vm._e()]), _vm._v(" "), (_vm.interfaces.includes('messenger') && _vm.isMessengerPhraseInvalid(idx)) ? _c('div', {
      staticClass: "output-validation-error"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    }), _vm._v(" Messenger: only letters, numbers, hyphens and underscores allowed (no spaces)\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "output-field-actions"
    }, [(_vm.editing.phrases[idx]) ? [_c('button', {
      staticClass: "output-icon-btn output-icon-btn--confirm",
      attrs: {
        "disabled": _vm.isPhraseOver(idx) || _vm.validating.phrases[idx] || (_vm.interfaces.includes('messenger') && _vm.isMessengerPhraseInvalid(idx))
      },
      on: {
        "click": function($event) {
          return _vm.savePhrase(idx)
        }
      }
    }, [_c('i', {
      class: _vm.validating.phrases[idx] ? 'fa fa-spinner fa-spin' : 'fa fa-check'
    })]), _vm._v(" "), _c('button', {
      staticClass: "output-icon-btn",
      on: {
        "click": function($event) {
          return _vm.cancelPhrase(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])] : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "output-icon-btn",
      class: {
        'output-icon-btn--copied': _vm.copiedKey === ("phrase_" + idx)
      },
      on: {
        "click": function($event) {
          return _vm.copy(phrase, 'phrase', null, ("phrase_" + idx))
        }
      }
    }, [_c('i', {
      class: _vm.copiedKey === ("phrase_" + idx) ? 'fa fa-check' : 'fa fa-copy'
    }), _vm._v(" "), (_vm.copiedKey === ("phrase_" + idx)) ? _c('span', {
      staticClass: "output-copied-label"
    }, [_vm._v("Copied!")]) : _vm._e()])], 2)]), _vm._v(" "), (_vm.errors.phrases[idx]) ? _c('div', {
      staticClass: "output-validation-error"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    }), _vm._v(" " + _vm._s(_vm.errors.phrases[idx]))]) : _vm._e(), _vm._v(" "), (!_vm.editing.phrases[idx]) ? _c('button', {
      staticClass: "output-click-edit",
      on: {
        "click": function($event) {
          return _vm.startEditPhrase(idx)
        }
      }
    }, [_vm._v("Click to edit")]) : _vm._e(), _vm._v(" "), (_vm.configLoading) ? _c('div', {
      staticClass: "output-loading"
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-spin"
    }), _vm._v(" Loading config…")]) : (_vm.interfaces.length) ? _vm._l((_vm.interfaces), function(ch) {
      return _c('div', {
        key: ("ch_" + idx + "_" + ch),
        staticClass: "output-channel-block"
      }, [_c('div', {
        staticClass: "output-divider"
      }), _vm._v(" "), _c('div', {
        staticClass: "output-channel-block-header"
      }, [_c('span', {
        staticClass: "output-channel-badge",
        class: ("output-ch-" + ch)
      }, [_vm._v(_vm._s(_vm.channelLabel(ch)))])]), _vm._v(" "), (!_vm.deepLinks[idx] || !_vm.deepLinks[idx][ch]) ? _c('div', {
        staticClass: "output-no-config"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-circle"
      }), _vm._v(" No configuration found\n            ")]) : [_c('div', {
        staticClass: "output-sub-label output-sub-label--mt"
      }, [_vm._v("DEEP LINK")]), _vm._v(" "), _c('div', {
        staticClass: "output-field-row output-dl-row"
      }, [_c('span', {
        staticClass: "output-field-value output-mono output-break-all"
      }, [_vm._v(_vm._s(_vm.deepLinks[idx][ch]))]), _vm._v(" "), _c('button', {
        staticClass: "output-icon-btn",
        class: {
          'output-icon-btn--copied': _vm.copiedKey === ("dl_" + idx + "_" + ch)
        },
        on: {
          "click": function($event) {
            return _vm.copy(_vm.deepLinks[idx][ch], 'deep_link', ch, ("dl_" + idx + "_" + ch))
          }
        }
      }, [_c('i', {
        class: _vm.copiedKey === ("dl_" + idx + "_" + ch) ? 'fa fa-check' : 'fa fa-copy'
      }), _vm._v(" "), (_vm.copiedKey === ("dl_" + idx + "_" + ch)) ? _c('span', {
        staticClass: "output-copied-label"
      }, [_vm._v("Copied!")]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "output-sub-label output-sub-label--mt"
      }, [_vm._v("SHORT URL")]), _vm._v(" "), _c('div', {
        staticClass: "output-field-row"
      }, [_c('span', {
        staticClass: "output-field-value output-mono output-break-all"
      }, [_vm._v(_vm._s(_vm.getShortUrl(idx, ch)))]), _vm._v(" "), _c('button', {
        staticClass: "output-icon-btn",
        class: {
          'output-icon-btn--copied': _vm.copiedKey === ("su_" + idx + "_" + ch)
        },
        on: {
          "click": function($event) {
            _vm.copy(_vm.getShortUrl(idx, ch), 'short_url', ch, ("su_" + idx + "_" + ch))
          }
        }
      }, [_c('i', {
        class: _vm.copiedKey === ("su_" + idx + "_" + ch) ? 'fa fa-check' : 'fa fa-copy'
      }), _vm._v(" "), (_vm.copiedKey === ("su_" + idx + "_" + ch)) ? _c('span', {
        staticClass: "output-copied-label"
      }, [_vm._v("Copied!")]) : _vm._e()])]), _vm._v(" "), _c('label', {
        staticClass: "output-checkbox-label"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.shortUrlState[idx] && _vm.shortUrlState[idx][ch] && _vm.shortUrlState[idx][ch].useCustom
        },
        on: {
          "change": function($event) {
            return _vm.toggleCustomUrl(idx, ch)
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v("Use custom URL")])]), _vm._v(" "), (_vm.shortUrlState[idx] && _vm.shortUrlState[idx][ch] && _vm.shortUrlState[idx][ch].useCustom) ? [_c('div', {
        staticClass: "output-custom-url-row"
      }, [_c('span', {
        staticClass: "output-url-prefix"
      }, [_vm._v(_vm._s(_vm.urlPrefix))]), _vm._v(" "), _c('input', {
        staticClass: "output-slug-input",
        class: {
          'output-slug-input--error': _vm.slugError(idx, ch)
        },
        domProps: {
          "value": _vm.shortUrlState[idx][ch].customSlug
        },
        on: {
          "input": function (e) { return _vm.onSlugInput(idx, ch, e.target.value); }
        }
      })]), _vm._v(" "), (_vm.slugError(idx, ch)) ? _c('div', {
        staticClass: "output-validation-error"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-circle"
      }), _vm._v(" " + _vm._s(_vm.slugError(idx, ch)))]) : _vm._e(), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "warn-fade"
        }
      }, [(_vm.shortUrlState[idx][ch].showWarning) ? _c('div', {
        staticClass: "output-url-warning"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-triangle output-warn-icon"
      }), _vm._v(" "), _c('span', [_vm._v("Changing the short URL will also update the QR code. The old URL will stop working.")]), _vm._v(" "), _c('div', {
        staticClass: "output-warn-actions"
      }, [_c('button', {
        staticClass: "output-warn-cancel-btn",
        on: {
          "click": function($event) {
            return _vm.cancelShortUrl(idx, ch)
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
        staticClass: "output-warn-confirm-btn",
        on: {
          "click": function($event) {
            return _vm.confirmShortUrl(idx, ch)
          }
        }
      }, [_vm._v("Confirm change")])])]) : _vm._e()]), _vm._v(" "), (!_vm.shortUrlState[idx][ch].showWarning && _vm.shortUrlState[idx][ch].customSlug.trim() && !_vm.slugError(idx, ch) && _vm.shortUrlState[idx][ch].customSlug !== _vm.shortUrlState[idx][ch].currentSlug) ? _c('div', {
        staticClass: "output-apply-row"
      }, [_c('button', {
        staticClass: "output-apply-btn",
        on: {
          "click": function($event) {
            return _vm.applyShortUrl(idx, ch)
          }
        }
      }, [_vm._v("Apply")]), _vm._v(" "), _c('span', {
        staticClass: "output-apply-hint"
      }, [_vm._v("Click to generate the short link and regenerate its QR code")])]) : _vm._e(), _vm._v(" "), (_vm.shortUrlState[idx][ch].justSaved) ? _c('span', {
        staticClass: "output-meta-saved-msg"
      }, [_c('i', {
        staticClass: "fa fa-check-circle"
      }), _vm._v(" Saved")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "output-sub-label output-sub-label--mt"
      }, [_vm._v("QR CODES")]), _vm._v(" "), _c('div', {
        staticClass: "output-qr-pair"
      }, [_c('div', {
        staticClass: "output-qr-block"
      }, [_c('div', {
        staticClass: "output-qr-block-label"
      }, [_vm._v("Deep link")]), _vm._v(" "), _c('div', {
        staticClass: "output-qr-img-wrap"
      }, [(_vm.qrCodes[idx] && _vm.qrCodes[idx][ch] && _vm.qrCodes[idx][ch].preview) ? _c('img', {
        staticClass: "output-qr-img",
        attrs: {
          "src": _vm.qrCodes[idx][ch].preview,
          "alt": ("QR " + (_vm.channelLabel(ch)) + " deep")
        }
      }) : _c('div', {
        staticClass: "output-qr-placeholder"
      }, [_c('i', {
        staticClass: "fa fa-qrcode output-qr-placeholder-icon"
      })])]), _vm._v(" "), _c('button', {
        staticClass: "output-download-btn output-download-btn--sm",
        on: {
          "click": function($event) {
            return _vm.downloadQr(idx, ch)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download"
      }), _vm._v(" Download")])]), _vm._v(" "), _c('div', {
        staticClass: "output-qr-block"
      }, [_c('div', {
        staticClass: "output-qr-block-label"
      }, [_vm._v("Short URL")]), _vm._v(" "), _c('div', {
        staticClass: "output-qr-img-wrap"
      }, [(_vm.shortQrCodes[idx] && _vm.shortQrCodes[idx][ch] && _vm.shortQrCodes[idx][ch].preview) ? _c('img', {
        staticClass: "output-qr-img",
        attrs: {
          "src": _vm.shortQrCodes[idx][ch].preview,
          "alt": ("QR " + (_vm.channelLabel(ch)) + " short")
        }
      }) : _c('div', {
        staticClass: "output-qr-placeholder"
      }, [_c('i', {
        staticClass: "fa fa-qrcode output-qr-placeholder-icon"
      })])]), _vm._v(" "), _c('button', {
        staticClass: "output-download-btn output-download-btn--sm",
        on: {
          "click": function($event) {
            return _vm.downloadShortQr(idx, ch)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download"
      }), _vm._v(" Download")])])]), _vm._v(" "), _c('label', {
        staticClass: "output-toggle-row",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.toggleNiviLogo(idx, ch)
          }
        }
      }, [_c('span', {
        staticClass: "output-toggle-label-sm"
      }, [_vm._v("Include Nivi logo (both QRs)")]), _vm._v(" "), _c('div', {
        staticClass: "output-toggle",
        class: {
          'output-toggle--on': _vm.niviLogoState[idx] && _vm.niviLogoState[idx][ch]
        }
      }, [_c('span', {
        staticClass: "output-toggle-knob"
      })])])]], 2)
    }) : _c('div', {
      staticClass: "output-loading"
    }, [_vm._v("No channels configured (interface missing in additional_details)")])], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "output-card output-meta-form-card"
  }, [_c('div', {
    staticClass: "output-card-label"
  }, [_vm._v("KEYWORD METADATA")]), _vm._v(" "), _c('div', {
    staticClass: "output-meta-form-row"
  }, [_c('label', {
    staticClass: "output-meta-label"
  }, [_vm._v("Keyword Use")]), _vm._v(" "), _c('nv-select', {
    staticClass: "output-meta-select",
    model: {
      value: (_vm.metaDrafts.keyword_usage),
      callback: function($$v) {
        _vm.$set(_vm.metaDrafts, "keyword_usage", $$v)
      },
      expression: "metaDrafts.keyword_usage"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Choose --")]), _vm._v(" "), _vm._l((_vm.keywordUseList), function(item, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": item.usage_type
      }
    }, [_vm._v(_vm._s(item.labels))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "output-meta-form-row"
  }, [_c('label', {
    staticClass: "output-meta-label"
  }, [_vm._v("Keyword Topic")]), _vm._v(" "), _c('nv-select', {
    staticClass: "output-meta-select",
    model: {
      value: (_vm.metaDrafts.topic),
      callback: function($$v) {
        _vm.$set(_vm.metaDrafts, "topic", $$v)
      },
      expression: "metaDrafts.topic"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Choose --")]), _vm._v(" "), _vm._l((_vm.topicList), function(item, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": item.display_name
      }
    }, [_vm._v(_vm._s(item.display_name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "output-card-label output-card-label--mt"
  }, [_vm._v("CAMPAIGN INFORMATION")]), _vm._v(" "), _c('div', {
    staticClass: "output-meta-form-row"
  }, [_c('label', {
    staticClass: "output-meta-label"
  }, [_vm._v("Campaign")]), _vm._v(" "), _c('nv-select', {
    staticClass: "output-meta-select",
    model: {
      value: (_vm.metaDrafts.campaign_name),
      callback: function($$v) {
        _vm.$set(_vm.metaDrafts, "campaign_name", $$v)
      },
      expression: "metaDrafts.campaign_name"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Choose a Campaign --")]), _vm._v(" "), _vm._l((_vm.campaignList), function(item, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": item.name
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "output-meta-form-row"
  }, [_c('label', {
    staticClass: "output-meta-label"
  }, [_vm._v("Campaign Code")]), _vm._v(" "), _c('div', {
    staticClass: "output-meta-input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaDrafts.campaignCode),
      expression: "metaDrafts.campaignCode"
    }],
    staticClass: "output-meta-input",
    attrs: {
      "placeholder": "Campaign Code"
    },
    domProps: {
      "value": (_vm.metaDrafts.campaignCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaDrafts, "campaignCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "output-meta-gen-btn",
    attrs: {
      "disabled": !_vm.kw || !_vm.kw.client_id,
      "title": "Generate code"
    },
    on: {
      "click": _vm.generateMetaCampaignCode
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "output-meta-form-row"
  }, [_c('label', {
    staticClass: "output-meta-label"
  }, [_vm._v("UTM Source")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaDrafts.utm_source),
      expression: "metaDrafts.utm_source"
    }],
    staticClass: "output-meta-input",
    attrs: {
      "placeholder": "UTM Source"
    },
    domProps: {
      "value": (_vm.metaDrafts.utm_source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaDrafts, "utm_source", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "output-meta-form-row"
  }, [_c('label', {
    staticClass: "output-meta-label"
  }, [_vm._v("UTM Medium")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaDrafts.utm_medium),
      expression: "metaDrafts.utm_medium"
    }],
    staticClass: "output-meta-input",
    attrs: {
      "placeholder": "UTM Medium"
    },
    domProps: {
      "value": (_vm.metaDrafts.utm_medium)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaDrafts, "utm_medium", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "output-meta-form-row"
  }, [_c('label', {
    staticClass: "output-meta-label"
  }, [_vm._v("UTM Campaign")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaDrafts.utm_campaign),
      expression: "metaDrafts.utm_campaign"
    }],
    staticClass: "output-meta-input",
    attrs: {
      "placeholder": "UTM Campaign"
    },
    domProps: {
      "value": (_vm.metaDrafts.utm_campaign)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaDrafts, "utm_campaign", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "output-meta-actions"
  }, [_c('button', {
    staticClass: "output-meta-save-btn",
    attrs: {
      "disabled": _vm.metaSaving
    },
    on: {
      "click": _vm.saveMetadata
    }
  }, [_c('i', {
    class: _vm.metaSaving ? 'fa fa-spinner fa-spin' : 'fa fa-check'
  }), _vm._v("\n            " + _vm._s(_vm.metaSaving ? 'Saving…' : 'Save Metadata') + "\n          ")]), _vm._v(" "), (_vm.metaSaved) ? _c('span', {
    staticClass: "output-meta-saved-msg"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Saved")]) : _vm._e()])])], 2)]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "output-header-left"
  }, [_c('span', {
    staticClass: "output-status-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "output-header-title"
  }, [_vm._v("Entry Point Ready")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "output-ad-attached"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Attached successfully")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-560bcd5b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/entry-points/create-new-entry-point/output-sidebar/OutputSidebar.vue
// module id = ws0Q
// module chunks = 1